import cn from 'classnames';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { TextField } from '@mui/material';
import { ButtonAdd } from '@features/events/common';
import { Close } from '@shared/assets';
import { Card, IconButton, ImageInput, ImageInputCropper, Textarea } from '@shared/ui';
import { fieldToUppercase } from 'library/helpers/events';
import * as st from './styles.module.scss';

export const Coach = (): JSX.Element => {
  const {
    control,
    register,
    setValue,
    formState: { errors },
  } = useFormContext();

  const {
    fields: coachFields,
    append: appendCoach,
    remove: removeCoach,
  } = useFieldArray({
    name: 'event_coach',
    control,
  });

  const showDelete = coachFields.length > 1;

  const coachTitle = coachFields.length > 1 ? 'Ведущие' : 'Ведущий';

  return (
    <fieldset className={st.coaches}>
      <h3>{coachTitle}</h3>
      <div className={st.coaches__add}>
        <ButtonAdd
          handler={() =>
            appendCoach({
              last_name: '',
              first_name: '',
              second_name: '',
              photo: '',
              description: '',
            })
          }
          disabled={!!errors.event_coach}
        />
      </div>
      {coachFields.map((field, index) => (
        <Card key={index} className={st.coach}>
          <div className={st.wrapper}>
            <div className={st.info}>
              <div className={cn(st.photo, coachFields.length === 1 && st.fullsize)}>
                <Controller
                  control={control}
                  name={`event_coach.${index}.photo`}
                  render={({ field: { value }, fieldState: { error } }) => (
                    <ImageInputCropper
                      aspect={[4, 4]}
                      iconVariant="person"
                      value={value}
                      onChange={(value) => {
                        value && setValue(`event_coach.${index}.photo`, value);
                      }}
                      isValid={!!error}
                    />
                  )}
                />
              </div>
              <div className={st.content}>
                <section className={st.info__name}>
                  <Controller
                    name={`event_coach.${index}.last_name` as `event_coach.0.last_name`}
                    control={control}
                    render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
                      <TextField
                        type="text"
                        size="small"
                        label="Фамилия"
                        error={!!error}
                        value={value}
                        onBlur={onBlur}
                        onChange={(e) => onChange((e.target.value = fieldToUppercase(e)))}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                  <Controller
                    name={`event_coach.${index}.first_name` as `event_coach.0.first_name`}
                    control={control}
                    render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
                      <TextField
                        type="text"
                        size="small"
                        label="Имя"
                        error={!!error}
                        value={value}
                        onBlur={onBlur}
                        onChange={(e) => onChange((e.target.value = fieldToUppercase(e)))}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                  <Controller
                    name={`event_coach.${index}.second_name` as `event_coach.0.second_name`}
                    control={control}
                    render={({ field: { onChange, value, onBlur } }) => (
                      <TextField
                        type="text"
                        size="small"
                        label="Отчество"
                        value={value}
                        onBlur={onBlur}
                        onChange={(e) => onChange((e.target.value = fieldToUppercase(e)))}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </section>
                <section className={st.info__description}>
                  <Controller
                    name={`event_coach.${index}.description` as `event_coach.0.description`}
                    control={control}
                    render={({ fieldState: { error } }) => (
                      <Textarea
                        autosize
                        label="О ведущем"
                        {...register(
                          `event_coach.${index}.description` as `event_coach.0.description`,
                          {
                            onChange: (e) => (e.target.value = fieldToUppercase(e)),
                          }
                        )}
                        required={!!error}
                      />
                    )}
                  />
                </section>
              </div>
            </div>
            {showDelete && (
              <div className={st.delete}>
                <IconButton variant="transparent" onClick={() => removeCoach(index)}>
                  <Close />
                </IconButton>
              </div>
            )}
          </div>
        </Card>
      ))}
    </fieldset>
  );
};
